module.exports = __webpack_public_path__ + "img/Group 3@2x.7b909221.png";